import {PerkAnalyticsUsageASchema} from '@cohort/admin-schemas/perkAnalytics';
import {PerkIntegrationIdSchema} from '@cohort/shared/schema/apps';
import {asArray, DateSchema} from '@cohort/shared/schema/common';
import {PaginationParamsSchema} from '@cohort/shared/schema/common/pagination';
import {PerkAccessStatusSchema, PerkTypeSchema} from '@cohort/shared/schema/common/perks';
import {z} from 'zod';

export const PerkAccessASchema = z.object({
  id: z.string().uuid(),
  createdAt: DateSchema,
  status: PerkAccessStatusSchema,
  lastUsageDate: DateSchema.nullable(),
  perk: z.object({
    id: z.string().uuid(),
    internalName: z.string(),
    imageFileKey: z.string().nullable(),
    type: PerkTypeSchema,
    perkIntegrationId: PerkIntegrationIdSchema.nullable(),
  }),
  digitalAssetCollection: z.object({
    tokenId: z.number(),
    digitalAssetCollectionId: z.string().uuid(),
    internalName: z.string(),
    imageFileKey: z.string(),
  }),
  usages: z.array(PerkAnalyticsUsageASchema).optional(),
});
export type PerkAccessADto = z.infer<typeof PerkAccessASchema>;

export const GetPerkAccessesParamsASchema = PaginationParamsSchema.extend({
  userId: z.string(),
  statuses: z.preprocess(asArray, z.array(PerkAccessStatusSchema).optional()),
  orderBy: z.enum(['availableSince', '-availableSince']).optional(),
});
export type GetPerkAccessesParamsADto = z.infer<typeof GetPerkAccessesParamsASchema>;
